(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vl-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('VlWelcomePopup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const sessionKey = 'vl-welcome50-seen';
  // Respect a popup already seen earlier in this browser session.
  const previousSessionKey = 'vl-welcome50-seen-1791951198';
  let previousFocus = null;
  let previousOverflow = '';
  const close = () => { if (dialog.open) dialog.close(); };
  dialog.querySelectorAll('[data-vl-popup-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  const copyButton = dialog.querySelector('[data-vl-popup-copy]');
  const status = dialog.querySelector('[data-vl-popup-status]');
  copyButton.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText('WELCOME50');
      status.textContent = dialog.dataset.copySuccess;
    } catch (_) {
      status.textContent = dialog.dataset.copyFallback;
    }
  });
  setTimeout(() => {
    if (!dialog.isConnected || document.visibilityState === 'hidden') return;
    try {
      if (sessionStorage.getItem(sessionKey) || sessionStorage.getItem(previousSessionKey)) return;
      sessionStorage.setItem(sessionKey, '1');
    } catch (_) { return; }
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  }, 1100);
})();
  } catch(e) { console.error(e); }
})();

})();
